import { useTranslation } from "react-i18next"
import { ReactNode } from "react"

export const FeaturesComponent = () => {
  const { t } = useTranslation("Features")

  const fetures: {
    name: ReactNode
    desc: ReactNode
    icon: ReactNode
  }[] = [
    { name: t("Dobierz optymalną długość profili"), desc: t("Dobierz optymalną długość profili.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe015;</span>) },
    { name: t("Dostosuj kolor profili do wypełnienia"), desc: t("Dostosuj kolor profili do wypełnienia.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00d;</span>) },
    { name: t("Dobierz odpowiedni łącznik"), desc: t("Dobierz odpowiedni łącznik.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe014;</span>) },
    { name: t("Zainstaluj drzwi przesuwne w płytkich wnękach"), desc: t("Zainstaluj drzwi przesuwne w płytkich wnękach.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00a;</span>) },
    { name: t("Zaoferuj komfortowe rozwiązania"), desc: t("Zaoferuj komfortowe rozwiązania.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe011;</span>) },
    { name: t("Zainstaluj drzwi przesuwne w wysokich pomieszczeniach"), desc: t("Zainstaluj drzwi przesuwne w wysokich pomieszczeniach.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe009;</span>) },
    { name: t("Dobierz tor do podłoża"), desc: t("Dobierz tor do podłoża.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe012;</span>) },
    { name: t("Zaoferuj dożywotnią gwarancję na układy jezdne"), desc: t("Zaoferuj dożywotnią gwarancję na układy jezdne.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe008;</span>) },
  ]

  return (
    <div className="w-full bg-white">
      <div className="mx-auto container">
        <div className="px-4 py-16">
          <hr className="mb-16 border-t-2 border-aluprofil-gray/20" />

          <h2 className="mb-16 w-full font-head font-normal text-5xl text-aluprofil-gray">
            {t("Korzyści")}
          </h2>

          <div className="grid grid-cols-1 flex-wrap gap-x-6 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
            {fetures.map(
                (feature, index) => (
                  <div key={index} className="flex flex-col gap-4">
                    <div className="w-18 h-18">
                      {feature.icon}
                    </div>

                    <div className="h-20 relative font-head font-bold text-2xl text-aluprofil-gray after:content-[''] after:absolute after:left-0 after:bottom-0 after:mt-4 after:w-12 after:h-0.25 after:block after:border-b after:border-b-aluprofil-red">
                      {feature.name}
                    </div>

                    <div className="text-base text-aluprofil-gray">
                      {feature.desc}
                    </div>
                  </div>
                )
              )
            }
          </div>
        </div>
      </div>
    </div>
  )
}
